module.exports = __webpack_public_path__ + "static/media/SBL-1.ee847827.jpeg";